<template>
    <div>
        <div class="head-container">
            <div>
                <div class="head-text-main">
                    Συμβουλευτικές Υπηρεσίες
                </div>
            </div>
        </div>
        <v-container class="main-text text-container">
            <v-row>
                <v-col>
                    Η <span class="green-text">NUTRISENSE ΙΚΕ</span>, εταιρία-τεχνοβλαστός του Γεωπονικού Πανεπιστημίου Αθηνών,  παρέχει υψηλού επιπέδου συμβουλευτική υποστήριξη για την θρέψη και την διαχείριση της λίπανσης κηπευτικών και ανθοκομικών καλλιεργειών τόσο στο έδαφος όσο και σε υδροπονικά συστήματα. Οι συμβουλευτικές υπηρεσίες που παρέχει η  NUTRISENSE ΙΚΕ περιγράφονται πιο αναλυτικά παρακάτω.
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <ol>
                        <li>
                            <strong>1.ΥΠΗΡΕΣΙΕΣ ΧΗΜΙΚΩΝ ΑΝΑΛΥΣΕΩΝ</strong>
                        </li>
                    </ol>
                    <p class="pl-4">
                        Η <span class="green-text">NUTRISENSE ΙΚΕ</span> προσφέρει πακέτα χημικών αναλύσεων και συνταγών θρέψης για την συνεχή υποστήριξη των παραγωγών μεγάλων και μικρών υδροπονικών μονάδων, αλλά και παραγωγών που καλλιεργούν στο έδαφος. Οι χημικές αναλύσεις θρεπτικών διαλυμάτων υδροπονίας, νερού, εδάφους και φυλλοδιαγνωστικής προσφέρονται σε συνεργασία και με το κύρος του Γεωπονικού Πανεπιστημίου Αθηνών.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <ol start="2">
                        <li>
                            <strong>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΒΕΛΤΙΣΤΟΠΟΙΗΣΗ ΛΙΠΑΝΣΗΣ</strong>
                        </li>
                    </ol>
                    <p class="pl-4">
                        <span class="green-text">NUTRISENSE ΙΚΕ</span> παρέχει εξειδικευμένες συμβουλευτικές υπηρεσίες για την διαχείριση των υδροπονικών καλλιεργειών, καθώς και γενικότερα των θερμοκηπιακών καλλιεργειών, αλλά και των υπαίθριων καλλιεργειών κηπευτικών στο έδαφος. Οι εξιδεικευμένοι γεωπόνοι της εταιρείας μας αναλαμβάνουν τον σχεδιασμό προγραμμάτων θρέψης – λίπανσης των καλλιεργειών για ολόκληρη την καλλιεργητική περίοδο, προσαρμοσμένων στις ανάγκες του κάθε παραγωγού. Τα προγράμματα αυτά περιλαμβάνουν οδηγίες για την βασική λίπανση στις καλλιέργειες στο έδαφος, καθώς και συνταγές θρεπτικών διαλυμάτων για την υδρολίπανση τόσο στις καλλιέργειες στο έδαφος όσο και στις υδροπονικές καλλιέργειες. Τα προγράμματα υδρολίπανσης δεν είναι προκαθορισμένα για όλη την καλλιεργητική περίοδο αλλά επικαιροποιούνται και αναπροσαρμόζονται τακτικά. Στις υδροπονικές καλλιέργειες, τα θρεπτικά διαλύματα που παρέχονται στην καλλιέργεια αναπροσαρμόζονται τακτικά λαμβάνοντας υπόψη δεδομένα χημικών αναλύσεων σε δείγματα θρεπτικού διαλύματος απορροής. Στις καλλιέργειες στο έδαφος, οι αναπροσαρμογές στο πρόγραμμα της υδρολίπανσης βασίζονται στο στάδιο ανάπτυξης του φυτού, αλλά και σε αναλύσεις εδάφους εφόσον το επιθυμεί ο καλλιεργητής.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    Για περισσότερες πληροφορίες, επικοινωνήστε μαζί μας! <br>
                    Email: nutrisense@nutrisense.online <br>
                    Τηλ. <br> Παναγιώτης Καλοζούμης: +30 698 286 3724 <br> Δημήτρης Σάββας: +30 694 589 3830
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.heading {
    color: #5FA936;
    font-size: 36px;
    font-weight: 700;
}

.head-container{
    background-image: url("~@/assets/about_a_head.png");
    min-height: 250px;
    height: auto;
    padding: 40px 20px;
    width: 100%;
    z-index: 0;
    color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-shadow: 0px 0px 20px #0304036b;
    margin-top: -50px;
}

.head-text-main {
    font-weight: 700;
    font-size: clamp(28px, 7vw, 96px);
}

.head-text-secondary {
    font-size: 32px;
}

.main-text {
    color: #646464;
    font-size: 16px;
    line-height: 26px;
}
.text-container {
    max-width: 90%;
}

.green-text {
    color: #006600;
    font-weight: bold;
}

@media (max-width: 960px) {
    .head-container {
        min-height: 200px;
    }
}

@media (max-width: 600px) {
    .head-container {
        padding: 30px 15px;
        min-height: 150px;
    }
}
</style>
